'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = undefined;

var _util = require('./_util');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function debug(msg) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  _util.debug.apply(null, ['[Audio] ' + msg].concat(args));
}

var HTMLAudio = window.Audio;
var guid = 0;

/**
 Obiekt służacy do faktycznego odtwarzania dźwięku. Bazuje na HTML5 Audio.
 Można podłączyć go do HTMLowej kontrolki za pomocą metody setControl,
 dzięki czemu sterować odtwarzeniem można za pomocą wizualnych elementów.

 Triggers events:
   load
   loadProgress (after 'load')
   duration (after 'load')
   play (after 'load' or 'pause')
   timeProgress (after 'play')
   waiting (after 'play')
   continue (after 'waiting')
   pause (after 'play' or 'waiting')
   stop (after 'play' or 'waiting')
   end (after 'play')
   unload
   volume
   error
 */

var Audio = (function () {
  function Audio() {
    _classCallCheck(this, Audio);

    this._track = undefined;
    this._playing = false;
    this._waiting = false;
    this._seek = 0;
    this._volume = 1;
    this._loaded = false;
    this._audioListeners = undefined;
    this._waitingCheck = this._waitingCheck.bind(this);
    this._audio = this._createAudio();
    this._triggerObj = (0, _jquery2.default)(this);
    this._trigger = this._triggerObj.triggerHandler.bind(this._triggerObj);
    this._callbacks = {};
    this._bindAudioEvents();
  }

  _createClass(Audio, [{
    key: 'on',
    value: function on(eventName, callback) {
      var handler = function handler() {
        callback.apply(null, Array.prototype.slice.call(arguments, 1));
      };
      this._triggerObj.on(eventName, handler);
      if (typeof callback.audio_guid === "undefined") {
        callback.audio_guid = guid++;
      }
      debug('on eventName=' + eventName + ' callback.audio_guid=' + callback.audio_guid);
      this._callbacks[eventName + ':' + callback.audio_guid] = handler;
      return this;
    }
  }, {
    key: 'off',
    value: function off(eventName, callback) {
      var handler = this._callbacks[eventName + ':' + callback.audio_guid];
      if (handler) {
        delete this._callbacks[eventName + ':' + callback.audio_guid];
        this._triggerObj.off(eventName, handler);
      }
      return this;
    }
  }, {
    key: 'load',
    value: function load(track) {
      if (!track) {
        throw "Undefined track!";
      }
      debug('load track.id=' + track.id + ' this._track.id=' + (this._track ? this._track.id : undefined));
      if (!this._track || track.id !== this._track.id) {
        this.unload();
        this._track = track;
        track.duration = (0, _util.timeToSeconds)(track.duration);
        // Ustawienie src spowoduje wczytanie nagłówków
        // i wywołanie _onAudioLoadedMetaData
        this._audio.src = track.src;
        this._trigger('load', [track]);
      }
      return this;
    }
  }, {
    key: 'unload',
    value: function unload() {
      var track = this._track;
      if (track) {
        this._track = undefined;
        this._pause();
        this._seek = 0;
        this._audio.src = "";
        this._loaded = false;
        this._trigger('unload', [track]);
      }
      return this;
    }
  }, {
    key: 'track',
    value: function track() {
      return this._track;
    }
  }, {
    key: 'play',
    value: function play() {
      debug('play');
      if (this._track && !this._playing && !this._waiting) {
        this._playing = true;
        this._audio.play();
        this._trigger('play');
      }
      return this;
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._pause('pause');
      return this;
    }
  }, {
    key: 'seek',
    value: function seek(_seek) {
      if (this._loaded) {
        var newTime = _seek * this._track.duration;
        if (this._audio.currentTime !== newTime) {
          this._audio.currentTime = newTime;
        }
      }
      if (_seek !== this._seek) {
        this._seek = _seek;
        this._trigger('seek', [_seek]);
      }
      return this;
    }
  }, {
    key: 'volume',
    value: function volume(_volume) {
      this._audio.volume = _volume;
      if (_volume !== this._volume) {
        this._volume = _volume;
        this._trigger('volume', [_volume]);
      }
      return this;
    }
  }, {
    key: '_pause',
    value: function _pause(eventName) {
      if (this._playing || this._waiting) {
        this._playing = false;
        this._waiting = false;
        this._clearWaitingCheck();
        this._audio.pause();
        if (eventName) {
          this._trigger('pause');
        }
      }
    }
  }, {
    key: '_onAudioLoadedMetaData',
    value: function _onAudioLoadedMetaData() {
      debug('_onAudioLoadedMetaData this._audio.duration=' + this._audio.duration + ' this._track.duration=' + this._track.duration);
      this._setTrackDuration(this._audio.duration);
    }
  }, {
    key: '_onAudioDurationChange',
    value: function _onAudioDurationChange() {
      // Event 'durationchange' is fired when in _onAudioLoadedMetaData audio duration
      // was not known yet
      debug('_onAudioDurationChange this._audio.duration=' + this._audio.duration + ' this._track.duration=' + this._track.duration);
      this._setTrackDuration(this._audio.duration);
    }
  }, {
    key: '_onAudioTimeUpdate',
    value: function _onAudioTimeUpdate() {
      if (this._audio.duration) {
        var seek = this._audio.currentTime / this._audio.duration;
        if (this._audio.duration * Math.abs(this._seek - seek) > 0.01) {
          // niższe różnice mogą oznaczać, że nadal jest oczekiwanie na buforowanie
          if (this._waiting) {
            this._waiting = false;
            this._playing = true;
            this._trigger('continue');
          }
          this._trigger('timeProgress', [seek]);
          this._seek = seek;
        }
        this._setWaitingCheck();
      }
    }
  }, {
    key: '_setTrackDuration',
    value: function _setTrackDuration(duration) {
      debug('_setTrackDuration duration=' + duration + ' this._seek=' + this._seek + ' this._loaded=' + this._loaded);
      if (!this._loaded && duration) {
        this._track.duration = duration;
        this._loaded = true;
        this._trigger('duration', [duration]);
        this.seek(this._seek);
      }
    }
  }, {
    key: '_setWaitingCheck',
    value: function _setWaitingCheck() {
      this._clearWaitingCheck();
      this._lastCheckedSeek = this._seek;
      this._lastCheckedTime = Date.now();
      this._checkPlayingTimeout = setTimeout(this._waitingCheck, 500);
    }
  }, {
    key: '_waitingCheck',
    value: function _waitingCheck() {
      debug('_waitingCheck: this._playing=' + this._playing);
      this._checkPlayingTimeout = undefined;
      if (this._playing) {
        var checkElapsed = Date.now() - this._lastCheckedTime;
        var audioElapsed = this._audio.duration * (this._seek - this._lastCheckedSeek);
        debug('_waitingCheck[inside]: checkElapsed=' + checkElapsed + ' audioElapsed=' + audioElapsed);
        if (0.9 * checkElapsed > audioElapsed) {
          this._playing = false;
          this._waiting = true;
          this._trigger('waiting');
        }
      }
    }
  }, {
    key: '_clearWaitingCheck',
    value: function _clearWaitingCheck() {
      clearTimeout(this._checkPlayingTimeout);
    }
  }, {
    key: '_onAudioEnded',
    value: function _onAudioEnded() {
      this._playing = false;
      this._waiting = false;
      this._trigger('end');
    }
  }, {
    key: '_onAudioWaiting',
    value: function _onAudioWaiting() {
      debug('_onAudioWaiting this._playing=' + this._playing);
      if (this._playing) {
        this._playing = false;
        this._waiting = true;
        this._trigger('waiting');
      }
    }
  }, {
    key: '_onAudioProgress',
    value: function _onAudioProgress() {
      var audio = this._audio;
      if (audio.buffered.length) {
        var loaded = audio.buffered.end(audio.buffered.length - 1) / audio.duration;
        this._trigger('loadProgress', [loaded]);
      }
    }
  }, {
    key: '_onAudioError',
    value: function _onAudioError() {
      this._audio.load(); // Error state reset
      this._pause();
      this._trigger('error');
    }
  }, {
    key: '_createAudio',
    value: function _createAudio() {
      var audio = new HTMLAudio();
      audio.autoplay = false;
      audio.preload = 'auto';
      audio.autobuffer = true;
      return audio;
    }
  }, {
    key: '_bindAudioEvents',
    value: function _bindAudioEvents() {
      var _this = this;

      if (!this._audioListeners) {
        this._audioListeners = {
          onLoadedMetaData: this._onAudioLoadedMetaData.bind(this),
          onDurationChange: this._onAudioDurationChange.bind(this),
          onTimeUpdate: this._onAudioTimeUpdate.bind(this),
          onEnded: this._onAudioEnded.bind(this),
          onWaiting: this._onAudioWaiting.bind(this),
          onProgress: this._onAudioProgress.bind(this),
          onError: this._onAudioError.bind(this)
        };
      }
      var audio = this._audio;
      audio.addEventListener('loadedmetadata', this._audioListeners.onLoadedMetaData, false);
      audio.addEventListener('loadeddata', this._audioListeners.onLoadedMetaData, false);
      audio.addEventListener('durationchange', this._audioListeners.onDurationChange, false);
      audio.addEventListener('timeupdate', this._audioListeners.onTimeUpdate, false);
      audio.addEventListener('ended', this._audioListeners.onEnded, false);
      audio.addEventListener('waiting', this._audioListeners.onWaiting, false);
      audio.addEventListener('stalled', this._audioListeners.onWaiting, false);
      audio.addEventListener('seeking', this._audioListeners.onWaiting, false);
      audio.addEventListener('progress', this._audioListeners.onProgress, false);
      audio.addEventListener('error', this._audioListeners.onError, false);

      // Bez progress i timeupdate bo zaśmiecają
      var html5Events = 'abort canplay canplaythrough durationchange emptied encrypted ended error interruptbegin interruptend loadeddata loadedmetadata loadstart mozaudioavailable pause play playing ratechange seeked seeking stalled suspend volumechange waiting'.split(' ');
      var html5EeventHandler = function html5EeventHandler(evt) {
        debug('HTML5 event: ' + evt.type + ' position=' + _this._audio.currentTime);
      };
      for (var i = 0; i < html5Events.length; i++) {
        var evtName = html5Events[i];
        audio.addEventListener(evtName, html5EeventHandler.bind(this), false);
      }
    }
  }]);

  return Audio;
})();

exports.Audio = Audio;